import React from 'react';
import classnames from 'classnames';

import * as Styled from './Tile.styles';
import PropTypes from 'prop-types';

export const Tile = ({ year, title, value, percent }) => {
  return (
    <Styled.Wrapper>
      <Styled.Title>
        <span>{title}</span>
        <span className="year">{year}</span>
      </Styled.Title>
      <Styled.Amount>{value} PLN</Styled.Amount>
      <Styled.Trend>
        <span className={classnames('percent', { red: percent < 0, green: percent > 0 })}>
          {percent > 0 && '+'}
          {percent}%
        </span>
        rok do roku
      </Styled.Trend>
    </Styled.Wrapper>
  );
};

Tile.propTypes = {
  title: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  percent: PropTypes.number,
};
